import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5017595a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "person-card__avatar-container" }
const _hoisted_2 = { class: "text-caption text-grey-6" }
const _hoisted_3 = { class: "text-caption text-grey-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "person-card" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_avatar, {
          size: "100px",
          color: "grey-3",
          "text-color": "grey-6",
          class: "person-card__avatar"
        }, {
          default: _withCtx(() => [
            (_ctx.person.primaryFace && _ctx.person.primaryFace.imageUrl)
              ? (_openBlock(), _createBlock(_component_q_img, {
                  key: 0,
                  src: _ctx.person.primaryFace.imageUrl,
                  ratio: 1,
                  fit: "cover",
                  class: "grayscale"
                }, {
                  error: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "fa fa-user-circle",
                      size: "40px"
                    })
                  ]),
                  _: 1
                }, 8, ["src"]))
              : (_openBlock(), _createBlock(_component_q_icon, {
                  key: 1,
                  name: "fa fa-user-circle",
                  size: "40px"
                }))
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_q_card_section, { class: "q-pa-sm text-center" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["text-body2 ellipsis", _ctx.person.label ? 'text-weight-medium text-grey-5' : 'text-grey-5 text-italic'])
          }, _toDisplayString(_ctx.person.label || 'Unnamed Person'), 3),
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.faceCount) + " face" + _toDisplayString(_ctx.faceCount !== 1 ? 's' : ''), 1),
          _createElementVNode("div", _hoisted_3, " Trashed " + _toDisplayString(_ctx.trashedAt), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_q_card_actions, { class: "q-pa-xs q-pt-none justify-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_btn, {
            size: "sm",
            flat: "",
            round: "",
            dense: "",
            icon: "fa fa-undo",
            color: "primary",
            loading: _ctx.restoring,
            disable: _ctx.restoring,
            onClick: _withModifiers(_ctx.restorePerson, ["stop"])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, { delay: 400 }, {
                default: _withCtx(() => [
                  _createTextVNode("Restore")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["loading", "disable", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}